<template>
  <v-app>
    <v-app-bar v-if="!isJoinTeamPage" color="#101010" app>
      <v-toolbar-title class="headline text-uppercase">
        <router-link class="grey-text" to="/">
          <v-icon large>mdi-fire</v-icon>
          MMPOF
        </router-link>
      </v-toolbar-title>
      <v-btn
        :to="`/hour/${currentHour}`"
        color="primary"
        id="btn-current-hour"
      >
        Current Hour
        <v-badge
        tile
        inline
        left
        color="black"
        >
          <template v-slot:badge>{{currentHour}}</template>
        </v-badge>
      </v-btn>
      <div v-for="(ques, id) in openQuestions" :key="id">
        <v-tooltip bottom v-if="ques.open">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" outlined :to="`/hour/${ques.hourNumber}/question/${ques.questionNumber}/`" class="open-ques">
              <v-badge :color="qBadgeColor(ques.activeParticiPants)">
                <template v-slot:badge>{{ particiPantsCount(ques.activeParticiPants) }}</template>
                Q{{ques.questionNumber}}
              </v-badge>
            </v-btn>
          </template>
          <span v-for="(particiPant, id) in ques.activeParticiPants" :key="id">{{particiPant}}<br/> </span>
        </v-tooltip>
      </div>
      <v-spacer></v-spacer>
      <v-icon class="helper-icon" @click="setRoomVolumeLow()" v-if="me.volumeControl" color="white">mdi-volume-low</v-icon>
      <v-icon class="helper-icon" @click="setRoomVolumeHigh()" v-if="me.volumeControl" color="white">mdi-volume-high</v-icon>
      <v-icon class="helper-icon" @click="isMuted = !isMuted" color="white">{{iconHandler(isMuted)}}</v-icon>
      <span  @click.stop="menu = !menu">{{ me.username }}</span>
      <v-btn @click.stop="menu = !menu" icon v-if="me.approved" :color="haveUnapprovedUsers && me.admin ? 'error' : ''">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <notification/>
      <router-view></router-view>
    </v-main>

    <Menu v-if="!isJoinTeamPage"
      v-model="menu"
    />
    <Toast />
  </v-app>
</template>

<script>
import Menu from '@/components/Menu'
import Notification from '@/components/Notification'
import Toast from '@/components/Toast.vue'

import bus from '@/plugins/event-bus'
import { wantBind } from '@/store'
import { mapState } from 'vuex'
import { includes } from 'lodash'

export default {
  name: 'App',
  components: {
    Menu,
    Notification,
    Toast,
  },
  data: () => ({
    hours: false,
    menu: false,
    currentQ: undefined,
    isMuted: false,
  }),
  computed: {
    ...mapState({
      me: state => state.me,
    }),
    isJoinTeamPage () {
      return this.$route.path === '/join-team' || this.$route.path === '/sign-in'
    },
    currentHour: function () {
      return this.$store.getters['currentHour/hourNumber']
    },
    openQuestions: function () {
      // return this.$store.getters['questions/currentHourOpenQuestions'](this.currentHour)
      return this.$store.getters['questions/currentHourAllQuestions']()
    },
    haveUnapprovedUsers: function () {
      return this.$store.getters['users/haveUnapprovedUsers']()
    },
  },
  mounted: async function () {
    wantBind(() => { this.$store.dispatch('currentHour/bindCurrent') })
    wantBind(() => { this.$store.dispatch('questions/bindCurrentHour', 45) })
    await this.$store.dispatch('users/bindUsers')
    await this.$store.dispatch('audioRecorder/bindAudioRecorder')
    bus.$on('question-opened', this.addToActivePants)
    bus.$on('question-closed', this.removeActivePants)
  },
  watch: {
    '$route' (to, from) {
      if (to.meta.title) document.title = to.meta.title
    },
    currentHour: function (newO) {
      if (newO !== undefined) {
        this.$store.dispatch('questions/bindCurrentHour', this.currentHour)
      }
    },
    openQuestions: function (newQuestions, existingQuestions) {
      if (newQuestions && existingQuestions) {
        let correctNewQuestions = newQuestions.flatMap(elem => {
          if (elem.correct) {
            return [elem.questionNumber]
          } else {
            return []
          }
        })
        let newlyCorrect = existingQuestions.filter(elem => {
          return elem.open && !elem.correct && correctNewQuestions.includes(elem.questionNumber)
        })
        newlyCorrect.forEach(elem => {
          let bell = new Audio('/assets/audio/BoxingBell-trim.m4a')
          if (!this.isMuted) {
            bell.play()
          }
        })
      }
    },
  },
  methods: {
    addToActivePants: function ({ question, questionKey }) {
      if (this.currentQ !== undefined) {
        this.removeActivePants()
      }

      if (!question.activeParticiPants || !includes(question.activeParticiPants, this.me.username)) {
        this.$store.dispatch('questions/addToActivePants', {
          hourNumber: question.hourNumber,
          questionKey: questionKey,
          username: this.me.username,
        })
      }
      this.currentQ = question
    },
    iconHandler: function (muteState) {
      return muteState ? 'mdi-bell-cancel' : 'mdi-bell'
    },
    removeActivePants: function () {
      this.$store.dispatch('questions/removeFromActivePants', {
        question: this.currentQ,
        username: this.me.username,
      })
      this.currentQ = undefined
    },
    qBadgeColor: (userArray) => {
      if (!userArray) {
        return 'red'
      }
      let userKeys = Object.keys(userArray)
      if (userKeys.length < 3) {
        return 'red'
      } else {
        return 'blue'
      }
    },
    particiPantsCount: (userArray) => {
      return (!userArray) ? 0 : Object.keys(userArray).length
    },
    setRoomVolumeHigh: function () {
      this.$store.dispatch('audioRecorder/setRoomVolumeHigh')
    },
    setRoomVolumeLow: function () {
      this.$store.dispatch('audioRecorder/setRoomVolumeLow')
    },
  },
}
</script>
<style scoped>
  .headline {
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 6rem;
    font-weight:  100;
    letter-spacing: 2px;
    text-align: center;
    color: #f35626;
    background-image: -webkit-linear-gradient(90deg, #f35626, #f9d302);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .grey-text {
    color: #777777;
    text-decoration: none;
  }
  .helper-icon {
    margin-right: 1rem;
  }
  #btn-current-hour {
    margin: 0 1rem;
  }
  .open-ques {
    margin: 0 .5rem;
  }
  .need {
    color: red;
  }
</style>
